import request from '@/utils/request';
// 客户列表
export const getCustomerList = (params: any) =>
  request({
    url: 'Customer/customerList',
    method: 'get',
    params
  });
  // 报修履历
export const getOrderHistory = (params: any) =>
  request({
    url: 'Customer/orderHistory',
    method: 'get',
    params
  });

export const getCustomerListHoutai = (params: any) =>
  request({
    url: 'Customer/Customer',
    method: 'get',
    params
  });
  // 添加已注册客户
export const addRegisterCustomer = (data: any) =>
  request({
    url: 'Customer/addRegisterCustomer',
    method: 'POST',
    data
  });
  // 添加客户Customer/Customer
export const addCustomer = (data: any) =>
  request({
    url: 'Customer/Customer',
    method: 'POST',
    data
  });
  // 编辑客户
export const editCustomer = (data: any) =>
  request({
    url: 'Customer/Customer',
    method: 'PUT',
    data
  });
  // 客户详情
export const getCustomerDetail = (params: any) =>
  request({
    url: 'Customer/getCustomerDetail',
    method: 'get',
    params
  });
// 我添加过的客户
export const getAddCus = (params: any) =>
  request({
    url: 'Customer/addCus',
    method: 'get',
    params
  });
// 添加过我的客户
export const getSerAdd = (params: any) =>
  request({
    url: 'Customer/serAdd',
    method: 'get',
    params
  });
// 添加为我的客户
export const agreeSerAdd = (data: any) =>
  request({
    url: 'Customer/agreeSerAdd',
    method: 'POST',
    data
  });
// 批量添加为我的客户
export const batchAgreeSerAdd = (params: any) =>
  request({
    url: 'Customer/batchAgreeSerAdd',
    method: 'get',
    params
  });
// 批量添加为我的客户
export const getCustomerLimit = (params: any) =>
  request({
    url: 'Customer/getCustomerLimit',
    method: 'get',
    params
  });
// // 查看客户群组 / 客户别名推单群组
// export const getAuthGroup = (params: any) =>
//   request({
//     url: 'Customer/authGroup',
//     method: 'get',
//     params
//   });
// 查看客户群组 获取人员
export const getWithAuthority = (params: any) =>
  request({
    url: 'Customer/getWithAuthority',
    method: 'get',
    params
  });

// // 添加对客别名群组
// export const addAliasGroup = (data: any) =>
//   request({
//     url: 'Customer/aliasGroup',
//     method: 'POST',
//     data
//   });

// // 编辑对客别名群组
// export const editAliasGroup = (data: any) =>
//   request({
//     url: 'Customer/aliasGroup',
//     method: 'PUT',
//     data
//   });

// 添加客户标识 增删改查
export const getCustomerTagList = (params: any) =>
  request({
    url: 'CustomerTag/tagList',
    method: 'get',
    params
  });
export const addCustomerTag = (data: any) =>
  request({
    url: 'CustomerTag/tag',
    method: 'post',
    data
  });
export const editCustomerTag = (data: any) =>
  request({
    url: 'CustomerTag/tag',
    method: 'PUT',
    data
  });
export const delCustomerTag = (data: any) =>
  request({
    url: 'CustomerTag/tag',
    method: 'DELETE',
    data
  });
  // 添加下级
export const addLevel = (data: any) =>
  request({
    url: 'Customer/addLevel',
    method: 'post',
    data
  });
export const delCustomer = (data: any) =>
  request({
    url: 'Customer/Customer',
    method: 'DELETE',
    data
  });
  // 授权设备导入
export const importCustomerDevice = (data: any) =>
  request({
    url: 'Customer/importDevice',
    method: 'post',
    data
  });
  // 导出客户
export const exportCustomer = (data: any) =>
  request({
    url: 'Customer/exportCustomer',
    method: 'post',
    data
  });
  // 客户二维码
export const qrcode = (params: any) =>
  request({
    url: 'Customer/qrcode',
    method: 'get',
    params
  });
  // 添加关联人员
export const relationUser = (data: any) =>
  request({
    url: 'Customer/relationUser',
    method: 'post',
    data
  });
  // 获取关联人员
export const relationUserList = (params: any) =>
  request({
    url: 'Customer/relationUserList',
    method: 'get',
    params
  });
// 人员关联客户列表
export const relationUserCustomerList = (params: any) =>
  request({
    url: 'Customer/relationUserCustomerList',
    method: 'get',
    params
  });

// 添加管理员
export const addCustomerAdmin = (data: any) =>
  request({
    url: 'Customer/addCustomerAdmin',
    method: 'post',
    data
  });
  // 导入客户
export const importCustomer = (data: any) =>
  request({
    url: 'Customer/importCustomer',
    method: 'post',
    data
  });
  // 批量下载二维码
export const batchDownloadqr = (data: any) =>
  request({
    url: 'Customer/batchDownloadqr',
    method: 'post',
    data
  });
  // 自定义导出列表
export const getCustomerQrCodeList = (params: any) =>
  request({
    url: 'Customer/getCustomerQrCodeList',
    method: 'get',
    params
  });
// 自定义导出模板列表
export const qrCodeTemplate = (params: any) =>
  request({
    url: 'Customer/qrCodeTemplate',
    method: 'get',
    params
  });
  // 添加模板
export const addQrCodeTemplate = (data: any) =>
  request({
    url: 'Customer/qrCodeTemplate',
    method: 'post',
    data
  });
  // 编辑模板
export const editorQrCodeTemplate = (data: any) =>
  request({
    url: 'Customer/qrCodeTemplate',
    method: 'PUT',
    data
  });
  // 删除模板
export const deleteQrCodeTemplate = (data: any) =>
  request({
    url: 'Customer/qrCodeTemplate',
    method: 'DELETE',
    data
  });
  // 添加申请人到客户
export const addUserToCustomer = (data: any) =>
  request({
    url: 'Customer/addUserToCustomer',
    method: 'post',
    data
  });
  // 修改上级
export const editParentCustomer = (data: any) =>
  request({
    url: 'Customer/editParentCustomer',
    method: 'PUT',
    data
  });
